<template>
  <base-card @close="close">
    <div id="add-on-creation-wrapper">
      <heading :heading="components[activeComponentIndex].component" />
      <Component
        :is="components[activeComponentIndex].component"
        :subject="subject"
        @name-input="nameInput"
        @photo-input="photoInput"
        @description-input="descriptionInput"
        @pricing-input="pricingInput"
      />
      <div class="button-container">
        <Button
          :text="components[activeComponentIndex].buttons[0]"
          @click="back"
        /><Button
          :text="components[activeComponentIndex].buttons[1]"
          @click="next"
        />
      </div></div
  ></base-card>
</template>
<script>
import Button from "@/Components/UI/Button.vue";
import Heading from "@/Components/UI/Heading.vue";
import BaseCard from "@/Components/UI/FloatingCards/BaseFloatingCard.vue";
import Details from "./Details.vue";
import Pricing from "./Pricing.vue";
export default {
  data() {
    return {
      activeComponentIndex: 0,
      components: [
        {
          component: "Details",
          buttons: ["Close", "Next"],
        },
        {
          component: "Pricing",
          buttons: ["Back", "Finish"],
        },
      ],
      subject: {
        id: "addOn" + new Date().getTime(),
        name: undefined,
        priceOption: undefined,
        pricing: {
          minUnits: undefined,
          flatRate: undefined,
          unitRate: undefined,
        },
        forms: [],
        contracts: [],
        photo: undefined,
        description: undefined,
      },
    };
  },
  computed: {},
  methods: {
    back() {
      if (this.activeComponentIndex > 0) {
        this.activeComponentIndex--;
      } else {
        this.close();
      }
    },
    next() {
      if (this.activeComponentIndex < 1) {
        this.activeComponentIndex++;
      } else {
        this.addAddOn();
      }
    },
    close() {
      this.$emit("close");
    },
    async addAddOn() {
      this.$emit("add-add-on", this.subject);
    },
    nameInput(value) {
      this.subject.name = value;
    },
    descriptionInput(value) {
      this.subject.description = value;
    },
    photoInput(photo) {
      this.subject.photo = photo;
    },
    pricingInput(pricing) {
      this.subject = { ...this.subject, ...pricing };
    },
    addForm(form) {
      this.subject.forms.push(form);
    },
    removeForm(form) {
      let index = this.subject.forms.indexOf(form);
      this.subject.forms.splice(index, 1);
    },
    addContract(contract) {
      this.subject.contracts.push(contract);
    },
    removeContract(contract) {
      let index = this.subject.contracts.indexOf(contract);
      this.subject.contracts.splice(index, 1);
    },
  },
  components: {
    BaseCard,
    Button,
    Heading,
    Details,
    Pricing,
  },
  created() {
    if (this.addOn) {
      this.subject = this.addOn;
      this.subject.pricing.unitRate = this.subject.pricing.unitRate / 100;
      this.subject.pricing.flatRate = this.subject.pricing.flatRate / 100;
    }
  },
  props: ["addOn"],
  emits: ["close", "add-add-on"],
};
</script>
<style scoped>
@media screen {
  .button-container {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
  }

  .scs-button {
    margin: 5px;
  }
  @media (min-width: 800px) {
    #add-on-creation-wrapper {
      width: fit-content;
    }
  }
}
</style>
